import React from "react";
const Loader = () => {
  return (
    <div>
      <div className="circle circle3"></div>
      <div className="circle circle4"></div>
    </div>
  );
};

export default Loader;
